import axios from '../utils/axios';
import { dispatch } from '../reducers/configureStore';
// import { setAuthData } from 'src/reducers/slices/AuthSLice';
import { setHideBeatLoader, setShowBeatLoader, setSnackBarAlert } from '../reducers/slices/AlertsSlice';
import { handleError } from '../utils/utils';
export const UserType = {
  SUPERADMIN: 1,
  COMPANY_ADMIN: 2,
  STANDARD_USER: 3,
  PRIMARY_ADMIN: 4
};

const getUserByIdFormatter = (data) => {
  return {
    id: data?.id,
    username: data?.username,
    email: data?.entity_url_email,
    userApps:
      data?.userApps?.map((app) => ({
        id: app?.id,
        userId: app?.user_id,
        appId: app?.app_id,
        userJson: app?.user_json
      })) || []
  };
};

const UserListFormatter = (user) => {
  return {
    id: user.id,
    user_name: user.username,
    entity_url_email: user.entity_url_email,
    guid: user.guid,
    type: user.type,
    account_status_choice: user.account_status_choice,
    is_active: user.is_active === true ? 'active' : 'inactive',
    created_using_invitation: user.invite && user.invite.is_invited !== null ? user.invite.is_invited : 0
  };
};

const InvitationFormatter = (initation) => {
  return initation.map((invite) => InvitationListFormatter(invite));
};

const InvitationListFormatter = (invitation) => {
  return {
    id: invitation.id,
    user_name: invitation.user_name,
    type: invitation.type,
    user_email: invitation.user_email,
    is_invited: invitation.is_invited,
    invitation_accepted_at: invitation.invitation_accepted_at,
    invitation_expired_at: invitation.invitation_expired_at
  };
};

const UserAppsFormatter = (invitation) => {
  return invitation.map((invite) => ({
    id: invite.id,
    userId: invite.user_id,
    appId: invite.app_id,
    userName: invite.user?.username,
    userGuid: invite.user?.guid,
    userJson: invite.user_json,
    appName: invite.app.name
  }));
};

const AppsFormatter = (apps) => {
  return apps.map((app) => ({ id: app.id, name: app.name }));
};

const UserFormatter = (users) => {
  return users.map((user) => UserListFormatter(user));
};
export const createAdmin = async (values) => {
  const payload = {
    first_name: values.firstName,
    last_name: values.lastName,
    email: values.email,
    password: values.password,
    password_confirmation: values.confirmPassword,
    is_active: values.isActive,
    type: values.accessLevel
  };
  try {
    const { data } = await axios.post('/api/users/', payload);

    if (data?.status) {
      return true;
    } else {
      dispatch(setSnackBarAlert({ message: data.message, severity: 'error' }));
    }
  } catch (error) {
    handleError(error);
  }
};

export const listUsers = async (params, signal) => {
  let userList = [];
  const body = {
    ...params
  };

  try {
    dispatch(setShowBeatLoader());
    const res = await axios.post('/api/user/listing', body, {
      ...(signal && { signal })
    });

    if (res.data) {
      const { data } = res;
      if (data) {
        userList = {
          ...paginationFormator(data),
          data: UserFormatter(data) ?? []
        };
      } else {
        dispatch(setSnackBarAlert({ message: data.message, severity: 'error' }));
      }
    }
  } catch (error) {
    if (error.code !== 'ERR_CANCELED') {
      console.error('Listing failer failed', error);
    }
  } finally {
    dispatch(setHideBeatLoader());
    return userList;
  }
};

export const deleteUser = async (userId) => {
  try {
    dispatch(setShowBeatLoader());
    const response = await axios.delete(`/api/users/${userId}`);
    if (response?.data?.status) {
      return true;
    } else {
      dispatch(setSnackBarAlert({ message: response?.data?.message, severity: 'error' }));
    }
  } catch (e) {
    handleError(e);
  } finally {
    dispatch(setHideBeatLoader());
  }
};

export const editAdmin = async (values, id) => {
  const payload = {
    id: id,
    first_name: values.firstName,
    last_name: values.lastName,
    email: values.email,
    password: values.password,
    password_confirmation: values.confirmPassword,
    is_active: values.isActive,
    type: values.accessLevel.toString()
  };
  try {
    const { data } = await axios.put('/api/users/admin', payload);
    if (data?.status) {
      return true;
    } else {
      dispatch(setSnackBarAlert({ message: data.message, severity: 'error' }));
    }
  } catch (error) {
    handleError(error);
  }
};

export const paginationFormator = (data) => {
  return {
    totalPages: data?.total_page_count ?? 1,
    currentPage: data?.page ?? 1,
    pageSize: data?.page_size ?? 10
  };
};
export const inviteUser = async (values) => {
  const apps = values?.apps;
  const raw_json = JSON.stringify(apps);
  const payload = {
    user_email: values.email,
    user_name: values.username,
    type: values.type,
    password: values.password,
    confirmPassword: values.confirmPassword,
    is_active: values.isActive,
    isEmailSend: values.isEmailSend,
    app_raw_json: raw_json,
    guid: values.guid,
    parent_entity_id: values.parentEntityId
  };
  try {
    dispatch(setShowBeatLoader());
    const response = await axios.post('/api/invited/user', payload);

    if (response?.status) {
      dispatch(setSnackBarAlert({ message: response.message, severity: 'success' }));
      return response;
    } else {
      const errors = response?.errors || [];
      const fieldErrors = [];
      const generalErrors = [];

      errors.forEach((error) => {
        if (error.field) {
          fieldErrors.push(error);
        } else {
          generalErrors.push(error.message || 'An unexpected error occurred.');
        }
      });

      if (generalErrors.length) {
        dispatch(setSnackBarAlert({ message: generalErrors, severity: 'error' }));
      }

      return fieldErrors;
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'An unexpected error occurred.';
    dispatch(setSnackBarAlert({ message: errorMessage, severity: 'error' }));
  } finally {
    dispatch(setHideBeatLoader());
  }
};

export const isInvitedByToken = async (invitation_token) => {
  const payload = {
    invitation_token
  };
  let isValid = false;
  let responseData = null;
  try {
    dispatch(setShowBeatLoader());
    const response = await axios.post('/api/invited/user/getToken', payload);

    if (response.status) {
      dispatch(setSnackBarAlert({ message: 'valid token!', severity: 'success' }));
      responseData = response?.data;
      isValid = true;
    } else {
      dispatch(setSnackBarAlert({ message: 'expired token!', severity: 'error' }));
    }
  } catch (error) {
    handleError(error);
  } finally {
    dispatch(setHideBeatLoader());
    return { isValid, responseData };
  }
};

export const listInvitations = async (params, signal) => {
  let invitationList = [];
  const body = {
    ...params
  };

  try {
    dispatch(setShowBeatLoader());
    const res = await axios.post('/api/invited/user/listing', body, {
      ...(signal && { signal })
    });

    if (res.data) {
      const { data } = res;
      if (data) {
        invitationList = {
          ...paginationFormator(data),
          data: InvitationFormatter(data) ?? []
        };
      } else {
        dispatch(setSnackBarAlert({ message: data.message, severity: 'error' }));
      }
    }
  } catch (error) {
    handleError(error);
  } finally {
    dispatch(setHideBeatLoader());
    return invitationList;
  }
};

export const resetPasswordByInvitedUser = async (username, password, confirmPassword) => {
  const payload = {
    username,
    password,
    password_confirmation: confirmPassword
  };
  try {
    dispatch(setShowBeatLoader());
    const response = await axios.post('/api/invited/user/reset-password', payload);

    if (response?.status) {
      dispatch(setSnackBarAlert({ message: response.message, severity: 'success' }));
    } else {
      dispatch(setSnackBarAlert({ message: response.message, severity: 'error' }));
    }
  } catch (error) {
    handleError(error);
  } finally {
    dispatch(setHideBeatLoader());
  }
};

export const deleteInvitationbyId = async (id) => {
  let isDeleted = false;
  try {
    dispatch(setShowBeatLoader());
    const data = await axios.delete(`/api/invited/user/${id}`);

    if (data?.status) {
      dispatch(setSnackBarAlert({ message: 'Deleted successfully', severity: 'success' }));
      isDeleted = true;
    } else {
      dispatch(setSnackBarAlert({ message: data.message, severity: 'error' }));
    }
  } catch (error) {
    handleError(error);
  } finally {
    dispatch(setHideBeatLoader());
    return isDeleted;
  }
};

export const listUserApps = async (params, signal) => {
  let userAppsList = [];

  try {
    dispatch(setShowBeatLoader());
    const res = await axios.post('/api/user_apps', params, {
      ...(signal && { signal })
    });

    if (res.data) {
      const { data } = res;

      userAppsList = {
        ...paginationFormator(data),
        data: UserAppsFormatter(data) ?? []
      };
    } else {
      dispatch(setSnackBarAlert({ message: res.data.message, severity: 'error' }));
    }
  } catch (error) {
    handleError(error);
  } finally {
    dispatch(setHideBeatLoader());

    return userAppsList;
  }
};

export const deleteUserAppbyId = async (id) => {
  let isDeleted = false;
  try {
    dispatch(setShowBeatLoader());
    const data = await axios.delete(`/api/user_apps/${id}`);

    if (data?.status) {
      dispatch(setSnackBarAlert({ message: 'Deleted successfully', severity: 'success' }));
      isDeleted = true;
    } else {
      dispatch(setSnackBarAlert({ message: data.message, severity: 'error' }));
    }
  } catch (error) {
    handleError(error);
  } finally {
    dispatch(setHideBeatLoader());
    return isDeleted;
  }
};

export const appListing = async (params, signal) => {
  let userAppsList = [];

  try {
    dispatch(setShowBeatLoader());
    const res = await axios.get('/api/user_apps/apps_list', params, {
      ...(signal && { signal })
    });

    if (res.data) {
      const { data } = res;

      userAppsList = { data: AppsFormatter(data) };
    } else {
      dispatch(setSnackBarAlert({ message: res.data.message, severity: 'error' }));
    }
  } catch (error) {
    handleError(error);
  } finally {
    dispatch(setHideBeatLoader());

    return userAppsList;
  }
};

export const bulkDeleteUserApps = async (ids) => {
  let isDeletedResponse = false;
  try {
    dispatch(setShowBeatLoader());

    const data = await axios.post('/api/user_apps/bulk-delete', { ids });

    if (data?.status) {
      dispatch(setSnackBarAlert({ message: 'Deleted successfully', severity: 'success' }));
      isDeletedResponse = true;
    } else {
      dispatch(setSnackBarAlert({ message: data.message, severity: 'error' }));
    }
  } catch (error) {
    handleError(error);
  } finally {
    dispatch(setHideBeatLoader());
    return isDeletedResponse;
  }
};

export const bulkUpdateUserApps = async (ids, parsedJson) => {
  let updatedResponse = null;

  try {
    dispatch(setShowBeatLoader());

    const data = await axios.post('/api/user_apps/bulk-update', { ids, json: parsedJson });

    if (data?.status) {
      dispatch(setSnackBarAlert({ message: 'Updated successfully', severity: 'success' }));
      updatedResponse = data;
    } else {
      dispatch(setSnackBarAlert({ message: data.message, severity: 'error' }));
    }
  } catch (error) {
    handleError(error);
  } finally {
    dispatch(setHideBeatLoader());
    return updatedResponse;
  }
};

export const getInvitationbyId = async (invitation_id) => {
  try {
    dispatch(setShowBeatLoader());
    const data = await axios.get(`/api/invited/user/${invitation_id}`);

    if (data.status) {
      return {
        guid: data.data?.guid,
        parentEntityId: data.data?.parent_entity_id,
        email: data.data?.user_email,
        username: data.data?.user_name,
        invitationToken: data.data?.invitation_token,
        userApps: data.data?.app_raw_json,
        type: data.data?.type
      };
    } else {
      dispatch(setSnackBarAlert({ message: data.message, severity: 'error' }));
    }
  } catch (error) {
    handleError(error);
  } finally {
    dispatch(setHideBeatLoader());
  }
};

export const updateUserInvitation = async (data, invitation_id) => {
  let updateUserInvitation = {};

  const rawJson = JSON.stringify(data.apps);
  const updateInvitationPayload = {
    user_email: data.email,
    user_name: data.username,
    type: data.type,
    app_raw_json: rawJson
  };

  try {
    dispatch(setShowBeatLoader());

    const data = await axios.put(`/api/invited/user/${invitation_id}`, updateInvitationPayload);

    if (data?.status) {
      dispatch(setSnackBarAlert({ message: 'Updated successfully', severity: 'success' }));
      updateUserInvitation = data;
    } else {
      dispatch(setSnackBarAlert({ message: data.message, severity: 'error' }));
    }
  } catch (error) {
    handleError(error);
  } finally {
    dispatch(setHideBeatLoader());
    return updateUserInvitation;
  }
};

export const getUserbyId = async (userId) => {
  let UserData = [];
  try {
    dispatch(setShowBeatLoader());
    const response = await axios.get(`/api/user/${userId}`);

    if (response?.status) {
      UserData = getUserByIdFormatter(response.data);
    } else {
      dispatch(setSnackBarAlert({ message: response.message, severity: 'error' }));
    }
  } catch (error) {
    handleError(error);
  } finally {
    dispatch(setHideBeatLoader());
    return UserData;
  }
};

export const updateListedUser = async (userId, values) => {
  const payload = {
    password: values.password || undefined,
    confirmPassword: values.confirmPassword || undefined,
    userApps: values.apps
      ? Object.entries(values.apps)
          .map(([appKey, userJson]) => ({
            appId: parseInt(appKey.replace('app_', ''), 10),
            userJson: userJson && userJson !== '' ? (typeof userJson === 'string' ? JSON.parse(userJson) : userJson) : null
          }))
          .filter((app) => app.userJson !== null)
      : []
  };

  try {
    dispatch(setShowBeatLoader());
    const response = await axios.patch(`/api/user/admin/${userId}`, payload);

    if (response?.status) {
      dispatch(setSnackBarAlert({ message: 'User updated successfully', severity: 'success' }));
      return true;
    } else {
      dispatch(setSnackBarAlert({ message: response?.data?.message, severity: 'error' }));
    }
  } catch (error) {
    handleError(error);
  } finally {
    dispatch(setHideBeatLoader());
  }
};

export const sendForgotPasswordOTP = async (email) => {
  try {
    const response = await axios.post('/api/forgot-password', { email });
    if (response.status) {
      return true;
    }
    dispatch(setSnackBarAlert({ severity: 'error', message: response.errors?.[0].message }));
  } catch (error) {
    handleError(error);
  }
};

export const verifyOTP = async (otp, email) => {
  try {
    const response = await axios.post('/api/verify-otp-forgot-password', { otp, email });
    if (response.status) {
      return true;
    }
    dispatch(setSnackBarAlert({ severity: 'error', message: response.message }));
  } catch (error) {
    handleError(error);
  }
};

export const resetPassword = async (email, otp, password, confirmPassword) => {
  try {
    const response = await axios.post('/api/reset-password/', { otp, email, password, password_confirmation: confirmPassword });
    if (response.status) {
      dispatch(setSnackBarAlert({ severity: 'success', message: 'Password changed successfully.' }));
      return true;
    }
    dispatch(setSnackBarAlert({ severity: 'error', message: response.errors?.[0].message }));
  } catch (error) {
    handleError(error);
  }
};

export const getParentEntityName = async (tokenId) => {
  try {
    const response = await axios.get(`/api/orgToken/${tokenId}`);
    if (response?.status) {
      return response.data;
    } else {
      dispatch(setSnackBarAlert({ severity: 'error', message: response.message }));
    }
  } catch (error) {
    dispatch(setSnackBarAlert({ message: error.message, severity: 'error' }));
    handleError(error);
  }
};

export const userRegister = async (values, searchQuery, dispatch, navigate) => {
  try {
    let responseData = {};

    if (searchQuery?.token) {
      const payload = { ...values, token: searchQuery.token };
      responseData = await axios.post('/api/signup', payload);
    } else if (searchQuery?.tokenId) {
      const { remember, ...filteredValues } = values;
      const payload = { ...filteredValues, tokenId: searchQuery.tokenId };
      responseData = await axios.post(`/api/orgToken/signup/`, payload);
    }

    if (responseData.status) {
      dispatch(setSnackBarAlert({ message: responseData.message, severity: 'success' }));
      navigate('/signin');
      return responseData;
    } else {
      return responseData;
    }
  } catch (error) {
    handleError(error);
  }
};

export const listOrgTokens = async (params, signal) => {
  let orgTokenList = {};

  try {
    dispatch(setShowBeatLoader());
    const response = await axios.post('/api/orgToken/listing', params, {
      ...(signal && { signal })
    });
    if (response?.data) {
      const { data } = response;
      if (data) {
        orgTokenList = {
          ...paginationFormator(data),
          data: data ?? []
        };
      } else {
        dispatch(setSnackBarAlert({ message: response.data.message, severity: 'error' }));
      }
    }
  } catch (error) {
    handleError(error);
  } finally {
    dispatch(setHideBeatLoader());
    return orgTokenList;
  }
};

export const microservicesListing = async () => {
  try {
    const res = await axios.get('/api/microservices/listing');

    return res.data?.map((service) => ({ name: service.name, link: service.link }));
  } catch (error) {
    handleError(error);
  }
};
